import React from "react";
import { Modal } from "react-bootstrap";

import { commonErr } from "../common/errors";
import { getCancelTripReasons, cancelTrip } from "../../model/car";
import * as ROUTES from "../../constant/routes";

export default class CancelTrip extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			step: 0, //0 confirm 1: cancel trip 2: done
			errMsg: "",
			cancelReasons: null,
			ip_cancel_reason: "",
			ip_comment: "",
		};
	}

	componentDidMount() {
		getCancelTripReasons(this.props.trip.id).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					cancelReasons: resp.data.data.reasons,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	}

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	goToCancelTrip = () => {
		this.setState({
			step: 1,
		});
	};

	finishCancel = () => {
		this.props.hideModal();
		this.setState({
			step: 0,
			err: commonErr.INNIT,
			ip_cancel_reason: "",
			ip_comment: "",
		});
		this.getTrip();
	};

	getTrip = () => {
		this.props.getTrip(this.props.trip.id);
	};

	isValidCancelTrip = () => {
		if (!this.state.ip_cancel_reason || this.state.ip_cancel_reason === "" || this.state.ip_cancel_reason === "0") {
			return false;
		}
		if (this.state.ip_cancel_reason === "t0" && (!this.state.ip_comment || this.state.ip_comment === "")) {
			return false;
		}
		return true;
	};

	cancelTrip = () => {
		if (!this.isValidCancelTrip()) {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Vui lòng chọn lý do hoặc ghi rõ lý do của bạn.",
			});
		} else {
			cancelTrip(this.props.trip.id, this.state.ip_cancel_reason, this.state.ip_comment).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS) {
					this.setState({
						step: 2,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
				} else {
					this.setState({
						step: 2,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
				}
			});
		}
	};

	render() {
		var content;
		if (this.state.step === 2) {
			if (this.state.err >= commonErr.SUCCESS) {
				content = (
					<div className="modal-confirm-body">
						<p className="font-14">Huỷ chuyến thành công</p>
						<div className="wrap-btn">
							<a className="btn btn-primary btn--m" onClick={this.finishCancel}>
								Hoàn tất
							</a>
						</div>
					</div>
				);
			} else {
				content = (
					<div className="modal-confirm-body">
						<p className="font-14">Huỷ chuyến thất bại</p>
						<div className="wrap-btn">
							<a className="btn btn-primary btn--m" onClick={this.goToCancelTrip}>
								Thử lại
							</a>
						</div>
					</div>
				);
			}
		} else if (this.state.step === 1) {
			content = (
				<div className="modal-confirm-body owner-refuse2-body">
					<div className="line-form">
						<div className="custom-input">
							<div className="wrap-info">
								<div className="title-status">
									<p className="font-14">Vui lòng chọn lí do từ chối</p>
								</div>
							</div>
							<div className="custom-select">
								<select name="ip_cancel_reason" onChange={this.handleInputChange}>
									<option selected disabled hidden>
										Vui lòng chọn lý do hủy chuyến
									</option>
									{this.state.cancelReasons &&
										this.state.cancelReasons.map((reason) => <option value={reason.reason}>{reason.desc}</option>)}
								</select>
							</div>
						</div>
					</div>
					{/* <div className="custom-select">
						<select name="ip_cancel_reason" onChange={this.handleInputChange}>
							<option selected disabled hidden>
								Vui lòng chọn lý do hủy chuyến
							</option>
							{this.state.cancelReasons &&
								this.state.cancelReasons.map((reason) => <option value={reason.reason}>{reason.desc}</option>)}
						</select>
					</div> */}
					<div className="custom-textarea">
						<textarea
							placeholder="Vui lòng nhập lý do hoặc lời nhắn"
							name="ip_comment"
							onChange={this.handleInputChange}
						/>
					</div>
					<div className="wrap-btn">
						<a
							className="btn btn-primary btn--m"
							name="cancelTripBtn"
							disabled={!this.isValidCancelTrip()}
							onClick={this.cancelTrip}>
							Huỷ chuyến
						</a>
					</div>
				</div>
			);
		} else {
			content = (
				<div className="modal-confirm-body">
					<p className="font-14">Bạn có chắc muốn huỷ chuyến?</p>
					{this.props.trip.status >= 4 && (
						<p className="font-14">
							Lưu ý: Tuỳ vào thời điểm huỷ chuyến bạn có thể bị mất phí. Vui lòng xem thêm tại
							<a href={ROUTES.PRIVACY} target="_blank">
								<strong>chính sách huỷ chuyến</strong>
							</a>
							của Mioto.
						</p>
					)}
					<div className="wrap-btn">
						<a className="btn btn-primary btn--m" onClick={this.goToCancelTrip}>
							Tiếp tục
						</a>
					</div>
				</div>
			);
		}

		return (
			<Modal show={this.props.show} onHide={this.finishCancel} dialogClassName="modal-s modal-confirm">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Huỷ chuyến</h5>
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}
